// extracted by mini-css-extract-plugin
var _1 = "QADTEWYEj8";
var _2 = "e73tKyVojv";
var _3 = "VPfJ1a3m7o";
var _4 = "IjXYRskOl2";
var _5 = "ROzpsZXOqf";
var _6 = "FmKMjRPflA";
var _7 = "M65KhV4w4B";
export { _1 as "root", _2 as "size1", _3 as "size10", _4 as "size2", _5 as "size3", _6 as "size4", _7 as "size5" }
